module.exports = __webpack_public_path__ + "a4e5940c02c4809941925009393ce44e.svg";